import { render, staticRenderFns } from "./ChangeNpcAnswerEffect.vue?vue&type=template&id=00323b85&scoped=true&"
import script from "./ChangeNpcAnswerEffect.vue?vue&type=script&lang=js&"
export * from "./ChangeNpcAnswerEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00323b85",
  null
  
)

export default component.exports